import { Component } from '@angular/core';

@Component({
  selector: 'app-policies',
  imports: [],
  templateUrl: './policies.html',
  styleUrl: './policies.scss',
})
export class Policies {

}
